export const getPrivateChatsSelector = state => state.privateChats;
